import { ChevronDown, ChevronUp } from 'lucide-react'
import type { SortDirection } from 'hooks/useColumnSort'
import type { ProfileTableUiVariant } from 'components/ds/ProfileTable/types'
import { PROFILE_TABLE_VARIANT_STYLES } from 'components/ds/ProfileTable/variantStyles'

interface SortIconProps {
    direction?: SortDirection | null
    active: boolean
    uiVariant?: ProfileTableUiVariant
}

/**
 * Shared direction indicator for ProfileTable and the standalone tables: lucide's `ChevronUp` and `ChevronDown`
 * stacked into the up/down pair (the `ChevronsUpDown` look), always both chevrons. They are two icons rather than
 * one so each half takes its own color: an unsorted column shows the pair muted; a sorted one highlights the
 * chevron of its direction (up = ascending, down = descending) and leaves the other muted.
 *
 * Colors come from the variant registry rather than a local branch, so a new variant is
 * styled by registering it once in PROFILE_TABLE_VARIANT_STYLES and nothing here changes.
 */
export const SortIcon = ({ direction, active, uiVariant = 'default' }: SortIconProps) => {
    const { sortActive, sortInactive } = PROFILE_TABLE_VARIANT_STYLES[uiVariant]
    const upClass = active && direction !== 'desc' ? sortActive : sortInactive
    const downClass = active && direction === 'desc' ? sortActive : sortInactive
    return (
        <span aria-hidden="true" className="inline-flex shrink-0 flex-col items-center -space-y-1.5">
            <ChevronUp className={`h-3 w-3 ${upClass}`} strokeWidth={2.5} />
            <ChevronDown className={`h-3 w-3 ${downClass}`} strokeWidth={2.5} />
        </span>
    )
}
